import { render, staticRenderFns } from "./TaskNoteCard.vue?vue&type=template&id=d8656de2&"
import script from "./TaskNoteCard.vue?vue&type=script&lang=js&"
export * from "./TaskNoteCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports